import { useState } from "react";
import { Link } from "react-router-dom";
import { Container, SectionHeading } from "@/components/common/ui";
import { IMAGES, LIFESTYLES } from "@/lib/site";

const U = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=900&q=70`;
const PATHS = [
  { id: "pcs-in", title: "Moving to Hampton Roads", line: "PCS orders in hand — shortlist homes by commute to your base.", to: "/military", img: IMAGES.sailors },
  { id: "pcs-out", title: "Moving away", line: "Sell for 4.75% total, or let us manage it as a rental.", to: "/sellers#pcs-out", img: IMAGES.porch },
  { id: "veterans", title: "Veterans & retirees", line: "Put your V.A. loan benefit to work on a forever home.", to: "/military#va-loans", img: IMAGES.dock },
  { id: "local", title: "Local buyers & sellers", line: "First-time buyer specialists across Hampton Roads & Richmond.", to: "/buyers", img: IMAGES.kitchen },
];
const LIFESTYLE_IMG = {
  waterfront: IMAGES.dock, golf: U("photo-1789352050947-c87040ebe0cb"), "new-construction": U("photo-1771366260867-7e07094579d7"),
  "condo-townhome": U("photo-1625283518755-6047df2fb180"), luxury: IMAGES.pool, "active-adult": IMAGES.porch,
  acreage: U("photo-1720065609938-ec0e33ffd9ad"), pool: U("photo-1635111300299-e6e677daf7b7"),
};

const Tile = ({ to, img, title, line, testId, tall }) => (
  <Link to={to} data-testid={testId} className={`group relative block overflow-hidden rounded-md bg-neutral-900 ${tall ? "h-72" : "h-24"}`}>
    <img src={img} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-black/10" />
    <div className={`absolute inset-x-0 p-5 ${tall ? "bottom-0" : "top-1/2 -translate-y-1/2"}`}>
      <span className="text-lg text-white underline decoration-white/70 decoration-1 underline-offset-[6px] transition-[text-decoration-color] group-hover:decoration-brass">{title}</span>
      {line && <p className="mt-2 max-w-xs text-[14px] text-white/80">{line}</p>}
    </div>
  </Link>
);

export const AudiencePaths = () => (
  <section className="pb-16 sm:pb-20" data-testid="audience-paths">
    <Container>
      <SectionHeading title="However you're moving, we've got the watch" subtitle="Four ways families come to us, and where to start." />
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {PATHS.map((p) => <Tile key={p.id} {...p} tall testId={`path-${p.id}`} />)}
      </div>
    </Container>
  </section>
);

export const LifestyleTiles = () => {
  const [region, setRegion] = useState("Hampton Roads");
  return (
    <section className="py-16 sm:py-20" data-testid="lifestyle-tiles">
      <Container>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeading title="Find the lifestyle for you" subtitle="Waterfront, golf, new construction and more — across both of our markets." />
          <div className="grid grid-cols-2 rounded-full bg-neutral-100 p-1 text-[13px]">
            {["Hampton Roads", "Greater Richmond"].map((r) => (
              <button key={r} onClick={() => setRegion(r)} data-testid={`lifestyle-region-${r.toLowerCase().replace(/\s+/g, "-")}`}
                className={`rounded-full px-4 py-1.5 transition-colors ${region === r ? "bg-white font-medium shadow-sm" : "text-neutral-600"}`}>
                {r}
              </button>
            ))}
          </div>
        </div>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {LIFESTYLES.map((l) => (
            <Tile key={l.id} to={`/search?lifestyle=${l.id}&region=${encodeURIComponent(region)}`} img={LIFESTYLE_IMG[l.id]}
              title={`${l.label} ${region === "Hampton Roads" ? "Hampton Roads" : "Richmond"}`} testId={`lifestyle-${l.id}`} />
          ))}
        </div>
      </Container>
    </section>
  );
};
